<template>
  <div class="bulk-import">
    <div card v-if="success === 0 && errors.length === 0">
      <form @submit.stop.prevent="importGeoFencesCsv" v-if="success === 0 && errors.length === 0">
        <b-row>
          <b-col cols="12">
            <b-form-file
              v-model="theFile"
              :placeholder="this.$gettext('Choose a Moova standard GeoFences Import CSV File or drop it here...')"
              :drop-placeholder="this.$gettext('Drop file here...')"
              @input="fileChanged"
              ref="importedShippings"
              id="importedShippings"
              accept=".csv"
              class="my-3"
              v-if="!theFile"
            ></b-form-file>
          </b-col>
          <div class="text-center form-group col-12 form-actions">
            <b-button type="submit" variant="primary" size="sm" :disabled="!theFile || spinner" v-translate>Process File</b-button>
            <b-button type="button" variant="outline-primary" size="sm" @click.prevent="emitCancel" v-translate>Cancel</b-button>
          </div>
        </b-row>
      </form>
    </div>
    <div v-else-if="success > 0">
      <b-row>
        <b-col>
          <h3 class="my-5 text-center" v-translate="{geofencesQty: success}">%{geofencesQty} GeoFences and related data have been created! 😄</h3>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="text-center form-actions">
          <b-button type="button" variant="outline-primary" size="sm" @click.prevent="emitSuccess" v-translate>Close</b-button>
        </b-col>
      </b-row>
    </div>
    <div v-else>
      <b-row>
        <b-col>
          <h3 class="my-5" v-translate>There were errors processing the file</h3>
          <ul>
            <li v-for="(error, index) in errors" :key="index">
              <strong>{{ error.title }}</strong>: {{error.detail}}
            </li>
          </ul>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="text-center form-actions">
          <b-button type="button" variant="primary" size="sm" @click.prevent="resetData" v-translate>Start Over</b-button>
          <b-button type="button" variant="outline-primary" size="sm" @click.prevent="emitCancel" v-translate>Close</b-button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CsvImport',
  data() {
    return {
      file: null,
      theFile: null,
      success: 0,
      errors: []
    }
  },
  methods: {
    fileChanged(event) {
      if (this.theFile) {
        this.$store.dispatch('showSpinner')
        const formData = new FormData()
        formData.append('file', this.theFile, this.theFile.name)
        this.$http.post(this.$appConfig.api.baseUrl + 'companies/files', formData)
          .then(response => {
            this.file = response.body.full_path
            this.importGeoFencesCsv()
          }, error => { // no permissions for plain company user yet :/
            console.log(error)
            this.$root.$children[0].$refs.simplert.justCloseSimplert()
          })
          .finally(() => {
            this.$store.dispatch('hideSpinner')
          })
      }
    },
    importGeoFencesCsv() {
      if (!this.file) {
        this.$refs.uploader.warning = true
      } else {
        this.$store.dispatch('showSpinner')
        let payload = {
          file: this.file
        }
        this.$http.post(this.$appConfig.api.baseUrl + 'geo-fences/csv-import', payload)
          .then(response => {
            this.success = response.body.length
          }, () => {
            this.$emit('cancel')
          })
          .finally(() => {
            this.$store.dispatch('hideSpinner')
          })
      }
    },
    emitCancel() {
      this.$emit('cancel')
    },
    emitSuccess() {
      this.$emit('success')
    },
    resetData() {
      Object.assign(this.$data, this.$options.data.call(this))
    }
  }
}
</script>
